:host {
    
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 20%;
}


.element {
    line-height: 1;
}